/**
 * @file SonnerA11y.tsx
 * @description
 * -----------------------------------------------------
 * Componente de a11y para los toast de sonner
 * -----------------------------------------------------
 * @version 1.0.0
 * @created 2026-02-25
 * @author Correcta
 * @author Daniel Sentamans
 * @copyright © Correcta
 * @license Private
 */

"use client";

import { useEffect } from "react";

const applyToastA11y = (element: Element) => {
  if (!(element instanceof HTMLElement)) return;
  if (!element.matches("li[data-sonner-toast]")) return;
  const type = element.getAttribute("data-type");
  const isError = type === "error";
  element.setAttribute("role", isError ? "alert" : "status");
  element.setAttribute("aria-live", isError ? "assertive" : "polite");
};

const SonnerA11y = () => {
  useEffect(() => {
    const updateAll = () => {
      document
        .querySelectorAll("li[data-sonner-toast]")
        .forEach((node) => applyToastA11y(node));
    };

    updateAll();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches("li[data-sonner-toast]")) {
            applyToastA11y(node);
            return;
          }
          node
            .querySelectorAll("li[data-sonner-toast]")
            .forEach((item) => applyToastA11y(item));
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
};

export default SonnerA11y;
